const tiers = [
  { title: 'List it free', icon: 'ri-calendar-event-line', items: ['Your event on the GreenSide calendar'] },
  { title: 'Promote it', icon: 'ri-megaphone-line', items: ['Featured placement', 'Preview story', 'Newsletter mention', 'Recap with photos'], featured: true },
  { title: 'Sponsor a beat', icon: 'ri-award-line', items: ['One presenting sponsor per pillar'] },
];

export default function Partners() {
  return (
    <section id="partners" className="bg-background-100 px-4 md:px-8 py-16 md:py-24">
      <p className="font-label uppercase tracking-[0.28em] text-xs text-primary-600 font-semibold">Partners</p>
      <h2 className="font-heading font-bold text-4xl md:text-6xl text-foreground-950 leading-[1.02] mt-3 mb-10">Fill your field. Thank your sponsors.</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {tiers.map((t) => (
          <article key={t.title} className={`rounded-lg p-6 md:p-8 border ${t.featured ? 'bg-foreground-950 border-foreground-950 text-background-50' : 'bg-background-50 border-background-200 text-foreground-950'}`}>
            <span className={`w-12 h-12 rounded-md flex items-center justify-center text-2xl ${t.featured ? 'bg-accent-500 text-foreground-950' : 'bg-primary-100 text-primary-600'}`}><i className={t.icon}></i></span>
            <h3 className="mt-5 font-heading font-bold text-3xl">{t.title}</h3>
            <ul className="mt-4 space-y-2.5">
              {t.items.map((i) => (
                <li key={i} className="flex items-start gap-2 text-sm">
                  <span className={`w-5 h-5 flex items-center justify-center ${t.featured ? 'text-accent-400' : 'text-primary-500'}`}><i className="ri-check-line"></i></span>{i}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
      <div className="mt-8 flex flex-col md:flex-row md:items-center justify-between gap-5 bg-background-50 border-l-4 border-accent-500 rounded-lg p-5 md:p-6">
        <p className="text-foreground-800"><strong>Barter welcome:</strong> rounds of golf, food and beverage credits or merchandise.</p>
        <a href="tel:5622432854" className="bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-bold uppercase tracking-wider px-6 py-3 rounded-md whitespace-nowrap cursor-pointer text-center">Talk to us about your event</a>
      </div>
    </section>
  );
}